import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SeoTags } from '../../components';
import { ContactsComponent } from '../../components/info/ContactsComponent';
import { setShowSearch } from "../../store/appConfigsSlice";

const ContactsPage = () => {

	const dispatch = useDispatch();

	useEffect(() => {
    dispatch(setShowSearch(false));
  }, []);

	return (
		<>
			<SeoTags pageKey="contactsPage" />
			<ContactsComponent />
		</>
	)
}

export default withTranslation()(ContactsPage);